module.exports = __webpack_public_path__ + "img/PAMMHeadModel.1b50abdb.png";